import React, { FC, useRef } from "react";
import { ContentManager } from "../content-manager";
import type { ClearingInstitutionsDeriskProps } from "@/types";
import { SwiperCoverflow } from "../swiper";
import { useInView } from "@/hooks/reveal-in-view";
import SplitTextAnimation from "../split-text-animation";

export const ClearingInstitutionsDerisk: FC<
  ClearingInstitutionsDeriskProps
> = ({ content, gallery }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="clearingInstitutionsDerisk" ref={ref}>
      <div className="wrapper">
        <SplitTextAnimation
          htmlElement={
            <ContentManager
              content={content}
              className="clearingInstitutionsDerisk--content"
              style={{
                transform: isInView ? "none" : `translateY(20px)`,
                opacity: isInView ? 1 : 0,
                transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
              }}
            />
          }
          isInView={isInView}
        />
      </div>
      <div
        style={{
          transform: isInView ? "none" : `translateY(20px)`,
          opacity: isInView ? 1 : 0,
          transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
        }}
      >
        <SwiperCoverflow
          slides={gallery}
          className="clearingInstitutionsDerisk--swiper"
        />
      </div>
    </section>
  );
};
